import { JSX } from "preact/jsx-runtime";
import { Typography } from "../Typography";
import css from "./Button.module.scss";
import { useTranslation } from "react-i18next";

export interface ButtonProps extends JSX.HTMLAttributes<HTMLButtonElement> {
  variant?: "cancel" | "cancel-waiting" | "cancel-auto" | "cash-out" | "bet";
  onClick?: (event: MouseEvent | TouchEvent) => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  // For cash-out button: amount to display. Accept number or preformatted string.
  multiplier?: number | string;
}

export const Button = ({
  onClick,
  type = "button",
  disabled = false,
  variant = "bet",
  multiplier,
  className,
  ...props
}: ButtonProps) => {
  const { t } = useTranslation();
  const handlePress = (event: MouseEvent | TouchEvent) => {
    if (disabled) return;
    event.preventDefault();
    onClick?.(event);
  };
  const btnVarians = {
    cancel: {
      style: css.cancel,
      title: t("main.cancel").toUpperCase(),
    },
    "cancel-waiting": {
      style: css.cancelWaiting,
      title: t("main.cancel").toUpperCase(),
      descr: t("main.awaiting_next_round"),
    },
    "cancel-auto": {
      style: css.cancel,
      title: t("main.cancel").toUpperCase(),
      descr: t("main.waiting_for_next_round"),
    },
    "cash-out": {
      style: css.cashOut,
      title: t("main.cash_out").toUpperCase(),
    },
    bet: {
      style: css.bet,
      title: t("main.place_bet").toUpperCase(),
    },
  } as const;
  const btnVariant = btnVarians[variant];

  return (
    <button
      type={type}
      className={`${css.btn} ${btnVariant?.style} ${className}`}
      onMouseDown={handlePress}
      onTouchStart={handlePress}
      disabled={disabled}
      {...props}
    >
      <Typography
        variant={multiplier != null ? "button2" : "button1"}
        color={variant === "bet" ? "black" : "white"}
      >
        {btnVariant.title}
      </Typography>
      {multiplier != null ? (
        <Typography variant="button1" color="white">
          {typeof multiplier === "number"
            ? `${multiplier.toFixed(2)} USD`
            : multiplier}
        </Typography>
      ) : null}
      {"descr" in btnVariant && btnVariant.descr ? (
        <Typography variant="caption" color="white">
          {btnVariant?.descr}
        </Typography>
      ) : null}
    </button>
  );
};
